export default Object.freeze({
  UNANIMOUS_VOTE: 'UNANIMOUS_VOTE',
  CONFLICT_RESOLUTION: 'CONFLICT_RESOLUTION',
  PRE_SCREENED: 'PRE_SCREENED',
  SUGGESTED_STOP: 'SUGGESTED_STOP',
  USER_INITIATED_STOP: 'USER_INITIATED_STOP',
  UPDATED_OUTCOME: 'UPDATED_OUTCOME',
});
